module.exports = __webpack_public_path__ + "static/shawna-power-up-cutout-a3fef6b0fc5b7edcf1869cc19149f4fa.png";